import { makeStyles } from 'tss-react/mui';
import { darkGrey } from "../../style/globalStyle";

const useStyles = makeStyles()((theme) => ({
  // ==========================================
  // ReportsEmptyState styles
  // ==========================================
  emptyStateContainer: {
    background: theme.palette.primary.primary100,
    padding: "13px 56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "56px",
    minHeight: "200px",
    borderRadius: "12px",
    margin: "16px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    border: `1px solid ${theme.palette.primary.primary200}`,
  },
  emptyStateIllustrationContainer: {
    flex: "0 0 280px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyStateContentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  emptyStateTitle: {
    fontWeight: 700,
    marginBottom: "4px",
    color: "#1a1a1a",
    fontSize: "24px",
    letterSpacing: "-0.5px",
  },
  emptyStateDescription: {
    marginBottom: "8px",
    color: "#546E7A",
    lineHeight: "1.6",
    fontSize: "15px",
  },

  // ==========================================
  // ReportGenerationFlow styles
  // ==========================================
  generationFlowContainer: {
    maxHeight: "calc(100vh - 200px)",
  },
  generationFlowTitle: {
    marginBottom: "1rem",
  },
  generationFlowCard: {
    padding: "1.5rem",
    marginBottom: "1.5rem",
    backgroundColor: "#FFFFFF",
  },
  formContainer: {
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
    },
  },
  stepper: {
    "& .MuiStepIcon-root": {
      color: "#e0e0e0",
      fontSize: "1.5rem",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: theme.palette.primary.main,
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: theme.palette.primary.main,
    },
    "& .MuiStepConnector-root": {
      flex: 1,
    },
    "& .MuiStepConnector-line": {
      borderColor: "#e0e0e0",
      borderTopWidth: 2,
    },
  },
  sectionTitle: {
    marginBottom: "16px",
    color: darkGrey,
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  reportsGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "24px",
  },
  reportCard: {
    cursor: "pointer",
    border: "1px solid #E0E0E0",
    borderRadius: "6px",
    transition: "all 0.2s",
    boxShadow: "none",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      boxShadow: "0 2px 8px rgba(84, 204, 84, 0.15)",
      backgroundColor: "rgba(84, 204, 84, 0.02)",
    },
  },
  reportCardContent: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 12px !important",
    minHeight: "auto",
  },
  reportIcon: {
    fontSize: "18px",
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
  reportTitle: {
    fontWeight: 500,
    marginBottom: "0px",
    fontSize: "0.8125rem",
    lineHeight: "1.4",
  },
  reportDescription: {
    fontSize: "0.6875rem",
    lineHeight: "1.3",
    marginTop: "2px",
  },
  selectedReportBox: {
    background: "#f5f5f5",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "24px",
  },
  selectedReportLabel: {
    color: "#666",
    marginBottom: "4px",
  },
  selectedReportName: {
    fontWeight: 600,
  },
  formatSelector: {
    marginBottom: "24px",
  },
  formatButton: {
    padding: "12px 24px",
    textTransform: "none",
  },
  formatButtonContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  formatButtonText: {
    textAlign: "left",
  },
  formatTitle: {
    fontWeight: 600,
  },
  formatSubtitle: {
    fontSize: "11px",
    color: "#666",
  },
  actionsContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    paddingTop: "16px",
    borderTop: "1px solid #e0e0e0",
    marginTop: "24px",
  },
  actionButton: {
    textTransform: "none",
  },
  submitButton: {
    textTransform: "none",
    float: "right",
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
    "&:disabled": {
      opacity: 0.7,
      color: "white",
      background: theme.palette.primary.main,
    },
  },
  emptyState: {
    textAlign: "center",
    padding: "40px",
    color: "#999",
  },
  emptyStateIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
}));

export default useStyles;
